import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  label: {
    description: 'Horizontal text align label',
    defaultMessage: 'Horizontal Align',
    id: 'oeJCrr',
  },
  left: {
    description: 'Left horizontal text alignment option',
    defaultMessage: 'Left',
    id: '8x8dJK',
  },
  center: {
    description: 'Center horizontal text alignment option',
    defaultMessage: 'Center',
    id: 'GVE5wQ',
  },
  right: {
    description: 'Right horizontal text alignment option',
    defaultMessage: 'Right',
    id: 'k/qUAj',
  },
});
